import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { CipoStateComponent } from '@shared/components/cipo-state/state.component';
import { DisplayFormats, TableColumn, TableRow } from '@shared/components/data-list/common';
import { GetMimeTypePipe } from '@shared/components/img-base64/common';
import { CipoImgBase64 } from '@shared/components/img-base64/img-base64.component';
import { PipesModule } from '@shared/modules/pipes.module';
import { SafeHtmlPipe, StripHtmlPipe } from '@shared/pipes';
import { UserStore } from '@signal-store/user.store';

@Component({
  selector: 'cipo-table-cell',
  imports: [
    CommonModule,
    TranslateModule,
    NgxSkeletonLoaderModule,
    PipesModule,
    MatIconModule,
    CipoImgBase64,
    GetMimeTypePipe,
    CipoStateComponent,
    StripHtmlPipe,
    SafeHtmlPipe,
  ],
  templateUrl: './table-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellComponent<T = TableRow> {
  userStore = inject(UserStore);
  column = input.required<TableColumn>();
  row = input.required<T>();
  noDataPlaceholder = input<string, string>('-', {
    transform: value => value || '-',
  });

  displayFormat = DisplayFormats;
}
